module.exports = __webpack_public_path__ + "static/NotoKufiArabic-Bold-b65a378488263d102d62c91d4aa6c93e.ttf";